/*! VueCurrencyFilter v3.4.2 by Irfan Maulana <github.com/mazipan> */
!function (r, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("VueCurrencyFilter", [], t) : "object" == typeof exports ? exports.VueCurrencyFilter = t() : r.VueCurrencyFilter = t();
}(global, function () {
  return function (r) {
    var t = {};
    function e(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return r[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }
    return e.m = r, e.c = t, e.d = function (r, t, n) {
      e.o(r, t) || Object.defineProperty(r, t, {
        enumerable: !0,
        get: n
      });
    }, e.r = function (r) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(r, "__esModule", {
        value: !0
      });
    }, e.t = function (r, t) {
      if (1 & t && (r = e(r)), 8 & t) return r;
      if (4 & t && "object" == typeof r && r && r.__esModule) return r;
      var n = Object.create(null);
      if (e.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: r
      }), 2 & t && "string" != typeof r) for (var o in r) e.d(n, o, function (t) {
        return r[t];
      }.bind(null, o));
      return n;
    }, e.n = function (r) {
      var t = r && r.__esModule ? function () {
        return r.default;
      } : function () {
        return r;
      };
      return e.d(t, "a", t), t;
    }, e.o = function (r, t) {
      return Object.prototype.hasOwnProperty.call(r, t);
    }, e.p = "/dist", e(e.s = 0);
  }([function (r, t, e) {
    "use strict";

    e.r(t);
    var n = Array.prototype.map,
      o = Array.isArray,
      a = Object.prototype.toString,
      u = {
        __isNull: function (r) {
          return null == r;
        },
        __isString: function (r) {
          return !!("" === r || r && r.charCodeAt && r.substr);
        },
        __isArray: function (r) {
          return o ? o(r) : "[object Array]" === a.call(r);
        },
        __isObject: function (r) {
          return r && "[object Object]" === a.call(r);
        },
        __defaults: function (r, t) {
          var e;
          for (e in r = r || {}, t = t || {}) t.hasOwnProperty(e) && null == r[e] && (r[e] = t[e]);
          return r;
        },
        __map: function (r, t, e) {
          var o,
            a,
            u = [];
          if (!r) return u;
          if (n && r.map === n) return r.map(t, e);
          for (o = 0, a = r.length; o < a; o++) u[o] = t.call(e, r[o], o, r);
          return u;
        }
      },
      i = {};
    function s(r, t) {
      return r = Math.round(Math.abs(r)), isNaN(r) ? t : r;
    }
    i.settings = {
      currency: {
        symbol: "$",
        format: "%s%v",
        decimal: ".",
        thousand: ",",
        precision: 2,
        grouping: 3
      },
      number: {
        precision: 0,
        grouping: 3,
        thousand: ",",
        decimal: "."
      }
    };
    var c = i.unformat = i.parse = function (r, t) {
        if (u.__isArray(r)) return u.__map(r, function (r) {
          return c(r, t);
        });
        if ("number" == typeof (r = r || 0)) return r;
        t = t || i.settings.number.decimal;
        var e = new RegExp("[^0-9-" + t + "]", ["g"]),
          n = parseFloat(("" + r).replace(/\((?=\d+)(.*)\)/, "-$1").replace(e, "").replace(t, "."));
        return isNaN(n) ? 0 : n;
      },
      f = i.toFixed = function (r, t) {
        t = s(t, i.settings.number.precision);
        var e = Number(i.unformat(r) + "e" + t),
          n = Math.round(e);
        return Number(n + "e-" + t).toFixed(t);
      },
      l = i.formatNumber = i.format = function (r, t, e, n) {
        if (u.__isArray(r)) return u.__map(r, function (r) {
          return l(r, t, e, n);
        });
        r = c(r);
        var o = u.__defaults(u.__isObject(t) ? t : {
            precision: t,
            thousand: e,
            decimal: n
          }, i.settings.number),
          a = s(o.precision),
          p = r < 0 ? "-" : "",
          y = parseInt(f(Math.abs(r || 0), a), 10) + "",
          m = y.length > 3 ? y.length % 3 : 0;
        return p + (m ? y.substr(0, m) + o.thousand : "") + y.substr(m).replace(/(\d{3})(?=\d)/g, "$1" + o.thousand) + (a ? o.decimal + f(Math.abs(r), a).split(".")[1] : "");
      },
      p = i.formatMoney = function (r, t, e, n, o, a) {
        if (u.__isArray(r)) return u.__map(r, function (r) {
          return p(r, t, e, n, o, a);
        });
        r = c(r);
        var f = u.__defaults(u.__isObject(t) ? t : {
            symbol: t,
            precision: e,
            thousand: n,
            decimal: o,
            format: a
          }, i.settings.currency),
          y = function (r) {
            var t = i.settings.currency.format;
            return "function" == typeof r && (r = r()), u.__isString(r) && r.match("%v") ? {
              pos: r,
              neg: r.replace("-", "").replace("%v", "-%v"),
              zero: r
            } : r && r.pos && r.pos.match("%v") ? r : u.__isString(t) ? i.settings.currency.format = {
              pos: t,
              neg: t.replace("%v", "-%v"),
              zero: t
            } : t;
          }(f.format);
        return (r > 0 ? y.pos : r < 0 ? y.neg : y.zero).replace("%s", f.symbol).replace("%v", l(Math.abs(r), s(f.precision), f.thousand, f.decimal));
      },
      y = i;
    function m(r) {
      return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (r) {
        return typeof r;
      } : function (r) {
        return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(r);
    }
    function b(r, t) {
      if (null == r) return {};
      var e,
        n,
        o = function (r, t) {
          if (null == r) return {};
          var e,
            n,
            o = {},
            a = Object.keys(r);
          for (n = 0; n < a.length; n++) e = a[n], t.indexOf(e) >= 0 || (o[e] = r[e]);
          return o;
        }(r, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(r);
        for (n = 0; n < a.length; n++) e = a[n], t.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(r, e) && (o[e] = r[e]);
      }
      return o;
    }
    var d = {
      install: function (r, t) {
        var e = {
          name: "currency",
          symbol: "",
          thousandsSeparator: ".",
          fractionCount: 0,
          fractionSeparator: ",",
          symbolPosition: "front",
          symbolSpacing: !0
        };
        u.__isNull(t) && (t = {});
        var n = u.__defaults(t, e),
          o = n.name,
          a = b(n, ["name"]);
        r.filter(o, function (r, t, e, n, o, i, s) {
          var c = u.__defaults({
            symbol: t,
            thousandsSeparator: e,
            fractionCount: n,
            fractionSeparator: o,
            symbolPosition: i,
            symbolSpacing: s
          }, a);
          "object" === m(t) && (c = u.__defaults(t, a));
          var f = 0,
            l = "-" === String(r).charAt(0);
          l && (r = String(r).slice(1));
          var p = parseFloat(r);
          isNaN(p) || (f = p);
          var b = "%s%v";
          return b = "front" === c.symbolPosition ? c.symbolSpacing ? "%s %v" : "%s%v" : c.symbolSpacing ? "%v %s" : "%v%s", c.fractionCount > 0 && (r = y.toFixed(r, c.fractionCount)), f = y.formatMoney(r, {
            format: b,
            symbol: c.symbol,
            precision: c.fractionCount,
            thousand: c.thousandsSeparator,
            decimal: c.fractionSeparator
          }), l && (f = "-" + f), f;
        }), r.prototype.$CurrencyFilter = {
          setConfig: function (r) {
            a = u.__defaults(r, e);
          },
          getConfig: function () {
            return a;
          }
        };
      }
    };
    t.default = d;
  }]);
});